export default __webpack_public_path__ + "static/media/addidas.c8c620f2.jpg";